/* eslint max-classes-per-file: 0 */

import {
  Event as Data,
  EventCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class EventsApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'events';

  protected readonly hasFinishSlash = false;
}
